(ns frontend.view.entity-viewers.events.message-editor
  (:require
   [common.localization :as loc]
   [frontend.actions.entity :as entity-actions]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(defn message-editor
  [{:keys [state entity-id externally-passed-entity viewed-entity-id on-reset! show-expanded? modal? props
           on-success-callback!]}]
  [editor-utils/editor
   {:state                state
    :always-expanded?     show-expanded?
    :modal?               modal?
    :activity-entity-id   entity-id
    :externally-passed-entity externally-passed-entity
    :viewed-entity-id     viewed-entity-id
    :full-width?          true
    :placeholder          (loc/tr :message-editor-placeholder)
    :activity-entity-type :note-message
    :wysiwyg-attribute    :note-message/message
    :init-draft-state!    (fn [update-draft!]
                            (update-draft! :common/related-entities #{viewed-entity-id})
                            (update-draft! :note-message/message-type :message.type/linkedin)
                            (update-draft! :note-message/type :inbound)
                            (update-draft! :note-message/timestamp (.getTime (js/Date.))))
    :entity-schema        (registry/get-schema @session/tenant-schema :entity.type/note-message)
    :mandatory-field?     false
    :on-success-callback! on-success-callback!
    :on-reset!            on-reset!
    :on-submit!           (fn [data on-success! on-error!]
                            (entity-actions/*->create
                             (-> (cu/remove-nil-vals data)
                                 (assoc :entity/type :entity.type/note-message))
                             (fn [resp]
                               (on-success! resp)
                               (when (fn? on-success-callback!)
                                 (on-success-callback! resp)))
                             on-error!))
    :submit-button-text   (loc/tr :create-note-message-button)
    :disabled-button-tooltip-text (loc/tr :message-add-one-association)}])
